import type { AxiosInstance } from 'axios';
import { DASHBOARD_CONFIG } from '@/config/dashboard';
import type { Edition } from '../../domain/entities/edition.entity';

export class EditionsApiDatasource {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getEditions(institution: string): Promise<Edition[]> {
    const { data } = await this.client.get<{ editions: Edition[] }>(
      '/v1/mockexamperformancedashboard/editions',
      { params: { institution, courseId: DASHBOARD_CONFIG.courseId } },
    );
    return data.editions;
  }
}
